import * as Redux from 'redux';
import * as _ from 'lodash';

import {ThunkService} from '../services/thunkService';
import * as DtoModule from '../models/dto';
import * as StoreModule from '../models/store';

export class CoachFeeTiersActions {

    static init(coachFeeTiers: Array<StoreModule.ICoachFeeTierStoreState>): (dispatch: any, getState: any, thunkService: ThunkService) => void {
        return (dispatch: any, getState: any, thunkService: ThunkService) => {
            dispatch({
                type: 'CoachFeeTiers/Init',
                payload: coachFeeTiers
            });
        };
    }
}
